module.exports = __webpack_public_path__ + "static/ThaiFDA_logo-799cefd86c0393a401face9786887b2c.png";